<template>
  <div>
    <div v-if="$vuetify.breakpoint.xsOnly" id="toggle">
      <div :class="{active: tabDocument}" @click="tabDocument = true" id="img-tab">Eredeti</div>
      <div :class="{active: !tabDocument}" @click="tabDocument = false" id="txt-tab">Fordítás</div>
    </div>
    <div
      :style="
        `display: flex;
        height: ${$vuetify.breakpoint.xsOnly ? 'calc(100vh - 330px)' : 'calc(100vh - 270px)'};
        background-color: #323639;
        `"
    >
      <!--Maga a doksik (50% szélesnek kell lennie, mobil nézetben pedig 100%) -->
      <div
        v-show="(tabDocument && $vuetify.breakpoint.xsOnly) || $vuetify.breakpoint.smAndUp"
        :style="`width: ${$vuetify.breakpoint.xsOnly ? '100%' : '50%'}; position: relative`"
      >
        <!-- Kiválasztva ország -->
        <swiper
          v-show="$route.params.country != null && !isDocumentsLoading && getDocuments.length > 0"
          class="slider"
          :options="documentsSwiperOption"
          ref="documentsSwiper"
        >
          <!-- Az országhoz tartozó dokumentumok -->
          <swiper-slide class="slide" v-for="(document, i) in getDocuments" :key="`i${i}`">
            <!-- A dokumentum oldalai -->
            <swiper class="slider" :options="pagesSwiperOptions" ref="pagesSwipers">
              <!-- A dokumentumhoz tartozó lapok -->
              <swiper-slide class="slide" v-for="(page, j) in document.pages" :key="`j${j}`">
                <div class="swiper-zoom-container">
                  <!-- A megjelenítendő lapok -->
                  <img class="swiper-lazy" style="height: 100%" :src="page.url">
                </div>
              </swiper-slide>
              <div class="swiper-pagination swiper-pagination-pages" slot="pagination"></div>
            </swiper>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination-documents" slot="pagination"></div>
        </swiper>

        <!-- Slider melletti gombok navigációs gombok -->
        <div v-if="!isDocumentsLoading" id="nav-img-container">
          <div
            v-if="getDocuments.length > 0"
            id="nav-img-index"
          >{{(documentsSwiper.activeIndex + 1) + " / " + getDocuments.length}}</div>

          <!-- Balra gomb -->
          <div id="nav-img-icons">
            <div
              v-if="getDocuments.length > 0"
              @click="documentsSwiper.slidePrev()"
              id="nav-img-left"
            >
              <img src="@/assets/ntk_nav_left_w.svg">
            </div>

            <!-- Add gomb. Nem szükséges vele foglalkoznod szerintem (ezért vuetify komponenst használok). -->
            <v-dialog
              lazy
              v-if="getCurrentUser"
              v-model="isShowAddDialog"
              max-width="500px"
              persistent
              transition="dialog-transition"
            >
              <div slot="activator" id="nav-img-add">
                <img src="@/assets/ntk_nav_add_w.svg">
              </div>
              <countries-document-dialog
                v-if="isShowAddDialog"
                :title="'Dokumentum felvétele'"
                :selectedObject="{}"
                :actionType="'save'"
                @onDataChange="requestDocuments(); isShowAddDialog = false"
                @onClose="isShowAddDialog = false"
              ></countries-document-dialog>
            </v-dialog>

            <!-- Edit gomb. Nem szükséges vele foglalkoznod szerintem (ezért vuetify komponenst használok) -->
            <v-dialog
              v-if="getCurrentUser && $route.query.document && $route.query.page"
              lazy
              v-model="isShowEditDialog"
              max-width="500px"
              transition="dialog-transition"
              persistent
            >
              <div slot="activator" id="nav-img-edit">
                <img src="@/assets/ntk_nav_edit_w.svg">
              </div>
              <countries-document-dialog
                v-if="isShowEditDialog"
                :title="'Dokumentum módosítása'"
                :selectedObject="selectedDocument"
                :actionType="'update'"
                @onDataChange="requestDocuments(); isShowEditDialog = false"
                @onClose="isShowEditDialog = false"
              ></countries-document-dialog>
            </v-dialog>

            <!-- Törlés gomb -->
            <v-dialog
              v-if="getCurrentUser && $route.query.document && $route.query.page"
              v-model="isShowDeleteDialog"
              persistent
              max-width="500px"
              transition="dialog-transition"
            >
              <div slot="activator" icon small id="nav-img-delete">
                <img src="@/assets/ntk_nav_delete_w.svg">
              </div>
              <v-card>
                <v-card-text class="headline">{{`${selectedDocument.document_name} törlése`}}</v-card-text>
                <v-card-text class="font-weight-bold">
                  Biztosan törli? (A törlés elfogadásával törlődik a dokumentumhoz tartozó összes kép,
                  valamint a fordítás!)
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="isLoading" @click="isShowDeleteDialog = false;">Mégse</v-btn>
                  <v-btn :loading="isLoading" @click="deleteDocument()">Törlés</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!--Jobbra gomb-->
            <div
              v-if="getDocuments.length > 0"
              @click="documentsSwiper.slideNext()"
              id="nav-img-right"
            >
              <img src="@/assets/ntk_nav_right_w.svg">
            </div>
          </div>
        </div>

        <!--LOADER-->
        <v-layout v-if="isDocumentsLoading" fill-height justify-center align-center row wrap>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-layout>

        <!-- Nincs kiválasztva ország -->
        <v-layout
          v-else-if="getDocuments.length == 0"
          style="width: 100%;"
          class="text-xs-center"
          row
          wrap
          fill-height
          align-center
          justify-center
        >
          <v-flex xs12>
            <div style="color: #ffffff;">Az országhoz nem töltöttek fel még dokumentumot</div>
          </v-flex>
        </v-layout>
      </div>
      <div
        v-show="(!tabDocument && $vuetify.breakpoint.xsOnly) ||  $vuetify.breakpoint.smAndUp"
        :style="`width: ${$vuetify.breakpoint.xsOnly ? '100%' : '50%'}`"
      >
        <!-- Nincs kiválasztva dokumentum-->
        <v-layout
          v-if="!isShowDocumentInfo || isDocumentsLoading || getDocuments.length == 0"
          class="text-xs-center"
          style="width: 100%; translateY(-50%);"
          row
          wrap
          fill-height
          align-center
          justify-center
        >
          <v-flex xs12>
            <div style="color: #ffffff;">Nincs kiválasztva dokumentum</div>
          </v-flex>
        </v-layout>
        <!-- Dokumentum fordítása (50% szélesnek kell lennie, mobil nézetben pedig 100%) -->
        <countries-document-info v-else :style="`width: 100%;`"></countries-document-info>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  documentsCollection,
  storage,
  db,
  documentInfoCollection
} from "../firebaseConfig";
import Raven from "raven-js";
import CountriesDocumentInfo from "../components/CountriesDocumentInfo.vue";
import CountriesDocumentDialog from "./CountriesDocumentDialog.vue";
import DocumentsMixin from "../mixins/DocumentsMixin";
import _ from "lodash";

export default {
  name: "Document",
  mixins: [DocumentsMixin],
  props: ["document", "page"],
  components: { CountriesDocumentInfo, CountriesDocumentDialog },
  data() {
    return {
      tabDocument: true,
      isShowAddDialog: false,
      isShowEditDialog: false,
      isShowDocumentInfo: false,
      isShowDeleteDialog: false,
      isLoading: false,
      documentsSwiper: {},
      pagesSwipers: [],
      documentsSwiperOption: {
        spaceBetween: 50,
        lazy: true,
        /*pagination: {
          el: ".swiper-pagination-documents",
          clickable: true
        },*/
        on: {
          slideChange: () => {
            const yearId = this.$route.params.year;
            const countryId = this.$route.params.country;

            this.$router.push({
              path: `/index/${yearId}/${countryId}`,
              query: {
                document: this.getDocuments[this.documentsSwiper.activeIndex]
                  .id,
                page: this.getDocuments[this.documentsSwiper.activeIndex].pages[
                  this.pagesSwipers[this.documentsSwiper.activeIndex]
                    .activeIndex
                ].uid
              }
            });
          }
        }
      },
      pagesSwiperOptions: {
        direction: "vertical",
        spaceBetween: 50,
        mousewheel: true,
        zoom: true,
        lazy: true,
        pagination: {
          el: ".swiper-pagination-pages",
          clickable: true
        },

        on: {
          zoomChange: (scale, imageEl, slideEl) => {
            if (scale == 1) {
              this.documentsSwiper.allowTouchMove = true;
              this.pagesSwipers[
                this.documentsSwiper.activeIndex
              ].allowTouchMove = true;
            } else {
              this.documentsSwiper.allowTouchMove = false;
              this.pagesSwipers[
                this.documentsSwiper.activeIndex
              ].allowTouchMove = false;
            }
          },
          slideChange: () => {
            const yearId = this.$route.params.year;
            const countryId = this.$route.params.country;

            this.$router.push({
              path: `/index/${yearId}/${countryId}`,
              query: {
                document: this.getDocuments[this.documentsSwiper.activeIndex]
                  .id,
                page: this.getDocuments[this.documentsSwiper.activeIndex].pages[
                  this.pagesSwipers[this.documentsSwiper.activeIndex]
                    .activeIndex
                ].uid
              }
            });
          }
        }
      }
    };
  },
  watch: {
    getDocuments: function(documents) {
      const documentId = this.$route.query.document;
      const pageId = this.$route.query.page;
      const yearId = this.$route.params.year;
      const countryId = this.$route.params.country;

      this.$nextTick(() => {
        this.pagesSwipers = _.map(this.$refs.pagesSwipers, pageSwiper => {
          return pageSwiper.swiper;
        });
      });

      this.initActiveIndexes();

      if ((documentId == null || pageId == null) && documents.length > 0) {
        this.slideToFirstSlide(documents);
      } else if (
        !_.find(documents, document => {
          return document.id == documentId;
        })
      ) {
        if (documents.length > 0) {
          this.slideToFirstSlide(documents);
        } else if (documentId != null || pageId != null) {
          this.$router.push({
            path: `/index/${yearId}/${countryId}`
          });
          this.isShowDocumentInfo = false;
        }
      } else {
        this.slideToActiveDocumentSlide();
      }
    }
  },
  computed: {
    ...mapGetters(["getCurrentUser", "getDocuments", "isDocumentsLoading"]),
    selectedDocument() {
      return (
        _.find(this.getDocuments, document => {
          return document.id == this.$route.query.document;
        }) || {}
      );
    }
  },
  methods: {
    initActiveIndexes() {
      this.documentsSwiper.activeIndex = 0;
      this.pagesSwipers.forEach(swiper => {
        swiper.activeIndex = 0;
      });
    },

    slideToActiveDocumentSlide() {
      const documentId = this.$route.query.document;
      const pageId = this.$route.query.page;
      const yearId = this.$route.params.year;
      const countryId = this.$route.params.country;

      this.documentsSwiper.activeIndex = _.findIndex(
        this.getDocuments,
        document => {
          return document.id == documentId;
        }
      );

      this.$nextTick(() => {
        const pageSwperActiveIndex = _.findIndex(
          this.getDocuments[this.documentsSwiper.activeIndex].pages,
          pages => {
            return pages.uid == pageId;
          }
        );

        if (pageSwperActiveIndex === -1) {
          this.$router.push({
            path: `/index/${yearId}/${countryId}`,
            query: {
              document: this.getDocuments[this.documentsSwiper.activeIndex].id,
              page: this.getDocuments[this.documentsSwiper.activeIndex].pages[0]
                .uid
            }
          });
          this.pagesSwipers[this.documentsSwiper.activeIndex].activeIndex = 0;
        } else {
          this.pagesSwipers[
            this.documentsSwiper.activeIndex
          ].activeIndex = pageSwperActiveIndex;
        }
        this.isShowDocumentInfo = true;
      });
    },
    slideToFirstSlide(documents) {
      this.$router.push({
        path: `/index/${this.$route.params.year}/${this.$route.params.country}`,
        query: {
          document: documents[0].id,
          page: documents[0].pages[0].uid
        }
      });
      this.isShowDocumentInfo = true;
    },
    async deleteImages(imageIds) {
      for (const imageId of imageIds) {
        await storage
          .child(`documents/${imageId}`)
          .delete()
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve();
    },
    async deleteDocuments(imageIds, batch, documentId) {
      for (const imageId of imageIds) {
        await documentInfoCollection
          .where("document_id", "==", documentId)
          .where("page_uid", "==", Number(imageId))
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              batch.delete(
                documentInfoCollection.doc(querySnapshot.docs[0].id)
              );
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve();
    },
    deleteDocument() {
      const documentId = this.$route.query.document;
      const pageId = this.$route.query.page;

      this.isLoading = true;

      var batch = db.batch();

      batch.delete(documentsCollection.doc(this.selectedDocument.id));

      this.deleteDocuments(
        _.map(this.selectedDocument.pages, page => {
          return page.uid;
        }),
        batch,
        documentId
      )
        .then(() => {
          return this.deleteImages(
            _.map(this.selectedDocument.pages, page => {
              return page.uid;
            })
          );
        })
        .then(() => {
          return batch.commit();
        })
        .then(() => {
          this.requestDocuments();
          this.isShowDocumentInfo = false;
        })
        .catch(err => {
          Raven.captureException(err);

          this.$notify({
            group: "app",
            text: `Sikertelen törlés:  ${err.message}`,
            type: "error "
          });
        })
        .finally(() => {
          this.isShowDeleteDialog = false;
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.documentsSwiper = this.$refs.documentsSwiper.swiper;
  }
};
</script>

<style scoped>
#toggle {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  user-select: none;
}

#nav-img-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 1;
}

#nav-img-index {
  flex: 1 0 auto;
  padding-left: 15px;
}

#nav-img-icons {
  display: flex;
  width: auto;
  height: 100%;
}

#nav-img-left,
#nav-img-edit,
#nav-img-add,
#nav-img-delete,
#nav-img-right {
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: opacity 200ms ease-in-out;
}

#nav-img-left:hover,
#nav-img-edit:hover,
#nav-img-add:hover,
#nav-img-delete:hover,
#nav-img-right:hover {
  opacity: 0.5;
}

.slider {
  display: flex;
  width: 100%;
  height: 100%;
}

.slide {
  height: 100%;
}
</style>

